import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import pickBy from './pickBy';
export var getEventHandlerProps = function getEventHandlerProps(props) {
  return pickBy(props, _isEventKey);
};
export var getNonEventHandlerProps = function getNonEventHandlerProps(props) {
  return pickBy(props, function (key, value) {
    return !_isEventKey(key, value);
  });
};
export var getEventsConfig = function getEventsConfig(props) {
  var eventProps = getEventHandlerProps(props);
  var eventsConfig = {};
  Object.keys(eventProps).forEach(function (eventName) {
    var configName = eventName.slice(2)[0].toLowerCase() + eventName.slice(3);
    eventsConfig[configName] = eventProps[eventName];
  });
  return eventsConfig;
};

var _isEventKey = function _isEventKey(key, value) {
  return key.indexOf('on') === 0 && key.length > 2 && typeof value === 'function';
};